import { PartialRealisationAllocationLogic } from 'further-types/lp/realisation';

export const realisationFormStorageKey = (vehicleId: string) =>
  `realisation-form-${vehicleId}`;

export const clearFormStorage = (vehicleId: string) =>
  sessionStorage.removeItem(realisationFormStorageKey(vehicleId));

export const hasStoredForm = (vehicleId: string) =>
  sessionStorage.getItem(realisationFormStorageKey(vehicleId)) !== null;

export const defaultHoldingClassRealisation = {
  holdingClassId: '',
  name: '',
  unitsSold: 0,
  partialRealisationAllocationLogic: PartialRealisationAllocationLogic.ProRata,
  unitsAllocationPerInvestment: [],
  cashConsiderationAmounts: {
    receivedConsiderationPerUnit: 0,
    receivedConsiderationTotal: 0,
    escrowConsiderationPerUnit: 0,
    escrowConsiderationTotal: 0,
    earnoutConsiderationPerUnit: 0,
    earnoutConsiderationTotal: 0,
    withholdingTaxPayable: 0,
  },
};
